module.exports = __webpack_public_path__ + "img/marquee_HMM.878f70dd.jpg";